import { render } from "./index.vue?vue&type=template&id=98e7be9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=98e7be9e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=98e7be9e&lang=scss"

import exportComponent from "/Users/pengq/IdeaProjects/xin-sheng-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e7be9e"]])

export default __exports__